import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider }  from "./hooks/useAuth";
import { ToastProvider } from "./hooks/useToast";
import Header       from "./components/Header";
import Footer       from "./components/Footer";
import HomePage     from "./pages/HomePage";
import StorefrontPage from "./pages/StorefrontPage";
import AdminPage    from "./pages/AdminPage";
import LoginPage    from "./pages/LoginPage";
import "./styles/global.css";

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <div className="page-wrap">
            <Header />
            <Routes>
              <Route path="/"            element={<HomePage />} />
              <Route path="/s/:slug"     element={<StorefrontPage />} />
              <Route path="/admin"       element={<AdminPage />} />
              <Route path="/admin/login" element={<LoginPage />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}
